import React, { useEffect, useState } from "react";
import useErrorHandle from "../../../constant/errorHandling/useErrorHandle";
import checkNetworkStatus from "../../common/networkStatus/CheckNetworkStatus";
import { brandingSetting, listSetting ,getInvoiceAnalytics} from "../../../services/apiServices";
import useShowAlert from "../../../utiles/AlertUtiles";
function StoreSetting({ isStore }) {
  const handleError = useErrorHandle();
  const [invoiceInfo, setInvoiceInfo] = useState(null);
  const showAlert = useShowAlert();
  const toggleItems = [
    {
      key: "negobillBrand",
      label: "NegoBill Branding",
      icon: "bx bx-store",
      settingLable: "negobillBranding",
      subtext: "Show or hide “Powered by NegoBill” on invoices and QR codes.",
    },
  ];

  const [toggles, setToggles] = useState({
    negobillBrand: true,
  });

  const [loading, setLoading] = useState({});

  const handleList = async () => {
    const id = isStore._id;
    try {
      checkNetworkStatus();
      const response = await listSetting(id);

      const results = response?.results || {};    

      const updated = {};
      toggleItems.forEach((item) => {
        updated[item.key] = !!results[item.settingLable];
      });

      setToggles(updated);

      setToggles(updated);
    } catch (error) {
      handleError(error);
    }
  };

  const handleUpdate = async (key, settingLable, value) => {
    try {
      setLoading((prev) => ({ ...prev, [key]: true }));

      checkNetworkStatus();

      const data = {
        mainstoreid: isStore._id,
        negobillBranding: value,
      };
      const response = await brandingSetting(data);
      setToggles((prev) => ({ ...prev, [key]: value }));
      showAlert("success", response?.message);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading((prev) => ({ ...prev, [key]: false }));
    }
  };
  const fetchInvoiceInfo = async () => {
  try {
    checkNetworkStatus();
      const data = {
        mainstoreid: isStore._id,       
      };
    const response = await getInvoiceAnalytics(data); 
    setInvoiceInfo(response?.results);
  } catch (error) {
    handleError(error);
  }
};

  useEffect(() => {
    handleList();
    fetchInvoiceInfo();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-lg-6">
          <div className="card shadow-sm border  radius-10">
            <div className="card-body">
              {toggleItems.map((item) => (
                <div
                  key={item.key}
                  className="d-flex justify-content-between align-items-center "
                >
                  <div className="d-flex align-items-start gap-3">
                    <i className={`${item.icon} fs-4 text-primary`}></i>
                    <div>
                      <div className="fw-semibold">{item.label}</div>
                      <small className="text-muted">{item.subtext}</small>
                    </div>
                  </div>

                  <div className="form-check form-switch position-relative">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={!!toggles[item.key]}
                      disabled={loading[item.key]}
                      onChange={(e) =>
                        handleUpdate(
                          item.key,
                          item.settingLable,
                          e.target.checked
                        )
                      }
                    />
                    <span
                      className={`fw-semibold small ms-2 small text-uppercase fw-bold
    }`}
                    >
                      {toggles[item.key] ? "ACTIVE" : "INACTIVE"}
                    </span>
                    {/* {loading[item.key] && (
                      <span
                        className="spinner-border spinner-border-sm position-absolute"
                        style={{ right: "-25px", top: "2px" }}
                      />
                    )} */}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
     
       <div className="col-lg-6">
        <div className="card shadow-sm border radius-10 h-100">
          <div className="card-body p-4">      
            <div className="d-flex align-items-center mb-4">
              <div className="p-2 bg-primary-subtle rounded-3 me-3">
                <i className="bi bi- receipt-cutoff text-primary fs-5"></i>
              </div>
              <h6 className="fw-bold mb-0">Invoice Configuration</h6>
            </div>

            <div className="row g-3">
          
              <div className="col-12 mb-2 ">
                <div className="bg-light p-3 rounded-3 text-center">
                  <small className="text-muted text-uppercase fw-bold d-block mb-1" style={{fontSize: '0.7rem'}}>
                   Current Financial Year
                  </small>
                  <span className="h5 fw-bold  d-block  mb-0">{invoiceInfo?.invoiceData?.financialyear || "-"}</span>
                </div>
              </div>

            
              <div className="col-6">
                <div className="p-2 border rounded-3">
                  <small className="text-muted d-block">Invoice Prefix</small>
                  <span className="fw-semibold text-primary">{invoiceInfo?.invoiceData?.orderprefix || "-"}</span>
                </div>
              </div>

              <div className="col-6">
                <div className="p-2 border rounded-3">
                  <small className="text-muted d-block">Last Generated Invoice</small>
                  <span className="fw-semibold text-dark">{invoiceInfo?.invoiceData?.orderprefix +invoiceInfo?.invoiceData?.ordernumber || "-"}</span>
                </div>
              </div>

            
              <div className="col-12 mt-3">
                <div className="d-flex justify-content-between align-items-center px-1">
                  <span className="text-muted small"></span>
                  <span className="badge rounded-pill bg-dark py-2 px-3">
                 Total Invoices :   {invoiceInfo?.totalCount || 0} 
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      </div>
     
    </>
  );
}

export default StoreSetting;
